//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import { history } from "../../services/payment";
import { showErrorMsg } from "../../utils/error";
import moment from "moment";
import { dateFormat } from "../../utils/plugin_helper";

export default {
  name: "PaymentHistoryPage",
  computed: {
    hideBackIcon() {
      if (this.$route.query.back) {
        if (this.$route.query.back === "plan") {
          return true;
        }
      }
      return false;
    },
    backText() {
      if (this.$route.query.back) {
        if (this.$route.query.back === "plan") {
          return this.$t("myPlanPage.pageTitle");
        }
      }
      // 如果没有指定返回页面则显示通过返回
      return this.$t("common.back");
    },
  },
  data() {
    return {
      historyList: [],
      offset: 0,
    };
  },
  async activated() {
    try {
      this.$loading.show();
      this.historyList = await history();
    } catch (e) {
      showErrorMsg(e);
    } finally {
      this.$loading.hide();
    }
  },
  methods: {
    /**
     * 如果指定后退页面则点击返回push到指定页面，浏览器就挡不住了
     */
    backClick() {
      if (this.$route.query.back) {
        if (this.$route.query.back === "plan") {
          this.$router.push({ name: "MyPlanPage" });
          return;
        }
      }
      this.$router.go(-1);
    },
    /**
     * 下拉刷新
     * @param done 刷新成功后回调
     */
    async refresh(done) {
      try {
        this.historyList = await history({});
        this.offset = 0;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        done();
      }
    },
    /**
     * 上啦加载更多
     * @param done 加成在成后回调
     */
    async infinite(done) {
      try {
        const list = await history({ offset: this.offset });
        this.historyList = [...this.historyList, ...list];
        this.offset += 10;
        done(list.length === 0);
      } catch (e) {
        showErrorMsg(e);
        done();
      }
    },
  },
  filters: {
    /**
     * 格式化文案，将{时间} 格式化成当地时间
     * @param str 需要格式化的字符串
     * @returns {string}
     */
    format(str) {
      // 寻找{
      const leftIndex = str.indexOf("{");
      if (leftIndex === -1) {
        return str;
      }
      const rightIndex = str.indexOf("}", leftIndex);
      const time = str.substring(leftIndex + 1, rightIndex);
      const date = dateFormat({ date: moment(time), format: "MMM DD, YYYY" });
      return (
        str.substring(0, leftIndex) +
        date +
        str.substring(rightIndex, str.length - 1)
      );
    },
  },
  components: { HiHeader },
};



// WEBPACK FOOTER //
// ./src/pages/payment/History.vue